import * as React from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import { visuallyHidden } from '@mui/utils';
import { useOutletContext, useNavigate } from 'react-router-dom';

import Service from '../../util/Service';
import { useProfile } from '../common/useProfile';
import { Alert, Snackbar } from '@mui/material';
import { temAcessoAoProjeto } from './ProjetoRoot';
import { Lock, LockOpen } from '@mui/icons-material';

// const headCells = [
//     {
//         id: 'name',
//         numeric: false,
//         disablePadding: true,
//         label: 'Nome',
//     },
//     {
//         id: 'calories',
//         numeric: false,
//         disablePadding: false,
//         label: 'Descrição',
//     }
// ];

export default function ProjetoTable() {
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(true);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [projetos, setProjetos] = React.useState([]);
    const [projetosRM, setProjetosRM]= React.useState();
    const [papeis, setPapeis]= React.useState();

    const { update } = useOutletContext();
    const navigate = useNavigate();
    const prof = useProfile();

    const [openSnack, setOpenSnack] = React.useState(false);
    const [msg, setMsg] = React.useState('');

    React.useEffect(() => {
        if(prof.isOk){
            const comp = {
                title: {
                    variant: 'h6',
                    txt: 'Lista de projetos'
                }
            }
            if (prof.temAcesso("rootProject") || prof.temAcesso("ProjectAdm")) 
            {
                comp.actions = [
                    {
                        nome: 'Novo Projeto',
                        ac: '/project/newProject'
                    }
                ]
            }
            update(comp)
            buscaProjetos();
            buscaProjetosRM();
            buscaPapeis();
        }
    }, [prof.isOk]);
    React.useEffect(()=>{
        if( projetosRM){
            const arr = [...projetos];
            for(const p of projetosRM.projects){
                arr.push({
                    id: p.id,
                    nome: p.name,
                    descricao: p.description,
                    isRedmine: true
                })
            }
            setProjetos(arr);
        }
    }, [projetosRM])

    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };
    function buscaProjetos() {
        setSelected([]);
        Service.GET('/api/projeto/buscaTodos').then(r => setProjetos(r));
    }
    function buscaProjetosRM(){
        Service.GET('/api/security/integration/redmine/projects').then(r => setProjetosRM(r));
    }
    function buscaPapeis(){
        Service.GET('/api/security/setting/buscaByTipo/papel').then(r => setPapeis(r));
    }

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };


    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - projetos.length) : 0;

    const visibleRows = React.useMemo(
        () =>
            [...projetos]
                .sort(getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
        [order, orderBy, page, rowsPerPage, projetos],
    );
    
    function handleDoubleClick(row) {
        console.log( row);
        
        
        if (temAcessoAoProjeto(row, prof, papeis, ["rootProject", "ProjectAdm", "PrjVisualizar"]) ) {
            if( row.rule && row.rule.length > 1){
                if( !prof.temAcesso(row.rule)){
                    setOpenSnack(true);
                    setMsg('Não tem acesso para ver o projeto!');
                    return;
                }
            }
            const id = row.isRedmine?"redmine_"+row.id:row.id;
            navigate('/project/pagina/' + id);
        } else {

            setOpenSnack(true);
            setMsg('Não tem acesso para ver o projeto!');
        }
    }
    const handleDelete=()=>{
        console.log(selected);
        let ok = true;
        for(let x of selected){
            const item = projetos.find(p => p.id === x)
            if( item && item.isRedmine) {
                ok = false;
                break;
            }
        }
        if( ok ){
            Service.POST('/api/security/projeto/removeLst', selected ).then(r => {
                console.log( r );
                buscaProjetos();
                buscaProjetosRM();
            });
        }else{
            setOpenSnack(true);
            setMsg("Projetos do Redmine não podem ser excluidos")
        }
    }
    return (
        <Box sx={{ width: '100%' }}>
            <Paper sx={{ width: '100%', mb: 0 }}>
                <EnhancedTableToolbar numSelected={selected.length} handleDelete={handleDelete}/>
                <TableContainer>
                    <Table
                        sx={{ minWidth: 750 }}
                        aria-labelledby="tableTitle"
                        size={dense ? 'small' : 'medium'}
                    >
                        <EnhancedTableHead
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            //onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={projetos.length}
                        />
                        <TableBody>
                            {visibleRows.map((row, index) => {
                                const isItemSelected = selected.includes(row.id);
                                const labelId = `enhanced-table-checkbox-${index}`;

                                return (
                                    <TableRow
                                        hover
                                        onClick={(event) => handleClick(event, row.id)}
                                        role="checkbox"
                                        aria-checked={isItemSelected}
                                        tabIndex={-1}
                                        key={row.id}
                                        selected={isItemSelected}
                                        sx={{ cursor: 'pointer' }}
                                        onDoubleClick={() => handleDoubleClick(row)}
                                    >
                                        <TableCell align='center'>
                                            {row.isRedmine && <img src='/redmine.ico' width='18px' height='18px' style={{marginRight:'5px'}}/>}
                                            {row.nome}
                                        </TableCell>
                                        <TableCell align='center'>
                                            {row.descricao}
                                        </TableCell>
                                        <TableCell align='right'>
                                            {row.rule && row.rule.length > 0 && <Lock />}
                                            {!(row.rule && row.rule.length > 0) && <LockOpen />}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                            {emptyRows > 0 && (
                                <TableRow
                                    style={{
                                        height: (dense ? 33 : 53) * emptyRows,
                                    }}
                                >
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={projetos.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
            {/* <FormControlLabel
                control={<Switch checked={dense} onChange={handleChangeDense} />}
                label="Dense padding"
            /> */}
            <Snackbar open={openSnack} autoHideDuration={6000} onClose={handleCloseSnack}>
                <Alert
                    onClose={handleCloseSnack}
                    severity="success"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {msg}
                </Alert>
            </Snackbar>
        </Box>
    );
}



function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}
function EnhancedTableHead(props) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell align='center' padding='normal' sortDirection={orderBy === "nome"}>
                    <TableSortLabel
                        active={orderBy === "nome"}
                        direction={orderBy === "nome" ? order : 'asc'}
                        onClick={createSortHandler("nome")}
                    >
                        Projeto
                        {orderBy === "nome" ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>
                <TableCell align='center' padding='normal' sortDirection={orderBy === "descricao"}>
                    <TableSortLabel
                        active={orderBy === "descricao"}
                        direction={orderBy === "descricao" ? order : 'asc'}
                        onClick={createSortHandler("descricao")}
                    >
                        Descrição
                        {orderBy === "descricao" ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>

                <TableCell align='right'>
                    <TableSortLabel>Publico</TableSortLabel>
                </TableCell>
            </TableRow>
        </TableHead>
    );
}

function EnhancedTableToolbar(props) {

    const prof = useProfile();
    const { numSelected, handleDelete } = props;
    const MontaDelete = () => {
        if (prof.temAcesso('rootProject')) {
            return (
                <Tooltip title="Delete">
                    <IconButton onClick={handleDelete}>
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>);
        }
    }
    return (
        <Toolbar
            sx={[
                {
                    pl: { sm: 2 },
                    pr: { xs: 1, sm: 1 },
                },
                numSelected > 0 && {
                    bgcolor: (theme) =>
                        alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                },
            ]}
        >
            {numSelected > 0 ? (
                <Typography
                    variant="subtitle1"
                    component="div"
                    sx={{
                        color: "inherit",
                        flex: '1 1 100%'
                    }}>
                    {numSelected} selected
                </Typography>
            ) : (
                <Typography
                    sx={{ flex: '1 1 100%' }}
                    variant="h6"
                    id="tableTitle"
                    component="div"
                >
                    Gerenciar projetos
                </Typography>
            )}
            {numSelected > 0 ? (<MontaDelete />)
                : (
                    <Tooltip title="Filter list">
                        <IconButton>
                            <FilterListIcon />
                        </IconButton>
                    </Tooltip>
                )}
        </Toolbar>
    );
}
